import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogProps,
  DialogTitle,
  Stack,
} from "@mui/material";
import { XButton } from "share-components/mui-wrap/button/x-button";
export type PrintPreviewDialogProps = DialogProps & {
  onPrintClicked?: () => void;
  headerAction?: React.ReactNode;
  footerAction?: React.ReactNode;
};
export const PrintPreviewDialog = ({
  onPrintClicked,
  headerAction,
  footerAction,
  ...props
}: PrintPreviewDialogProps) => {
  return (
    <Dialog {...props}>
      <DialogTitle>
        <Stack direction={"row"} justifyContent={"space-between"} spacing={1}>
          <Box>Xem trước bản in</Box>
          <Stack>{headerAction}</Stack>
        </Stack>
      </DialogTitle>
      <DialogContent>{props.children}</DialogContent>
      <DialogActions>
        <XButton
          variant="text"
          onClick={(e) => props.onClose?.(e, "escapeKeyDown")}
        >
          Hủy
        </XButton>
        {footerAction}
        <XButton variant="contained" onClick={onPrintClicked}>
          In
        </XButton>
      </DialogActions>
    </Dialog>
  );
};
